import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    if ('_ISRF_MAP' !== map.data.mapTypeCode) {
        return null
    }

    const onClick = () => map.isrf.addBranch()

    return {
        key: 'add-branch-to-isrf',
        label: '加入增量分支',
        onClick,
    }
}
